__turbopack_context__.v({
  "black": "Credits-module-scss-module__jxaikq__black",
  "blink": "Credits-module-scss-module__jxaikq__blink",
  "clickOpen": "Credits-module-scss-module__jxaikq__clickOpen",
  "credits": "Credits-module-scss-module__jxaikq__credits",
  "creditsAll": "Credits-module-scss-module__jxaikq__creditsAll",
  "creditsInner": "Credits-module-scss-module__jxaikq__creditsInner",
  "opened": "Credits-module-scss-module__jxaikq__opened",
  "row": "Credits-module-scss-module__jxaikq__row",
  "white": "Credits-module-scss-module__jxaikq__white",
});
